import { Box, BoxProps } from '@mui/material';
import clsx from 'clsx';

type BreadcrumbProps = BoxProps & { disabled?: boolean };

export const Breadcrumb = ({
  children,
  disabled,
  className,
  ...rest
}: BreadcrumbProps) => {
  return (
    <Box
      className={clsx(
        'DS-Breadcrumb-root',
        disabled && 'Mui-disabled',
        className
      )}
      sx={{
        '& > a': {
          color: 'inherit',
          textDecoration: 'inherit',
        },
      }}
      {...(disabled ? { 'aria-disabled': true } : { tabIndex: 1 })}
      {...rest}
    >
      {children}
    </Box>
  );
};
